import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import moment from 'moment';
import 'moment/locale/vi';

import AppRouter from 'routers/AppRouter/AppRouter';
import { store } from 'store';
import { Provider } from 'react-redux';
import { AuthProvider } from 'context/AuthProvider';
import { MqttProvider } from 'context/MqttProvider';
import { ToastContainer } from 'react-toastify';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import 'assets/bw_scss/blackwind.scss';
import 'assets/bw_scss/main.css';
import 'react-toastify/dist/ReactToastify.css';
import 'styles/PortalTokens.scss';
import 'styles/App.css';
import 'styles/BaoChauPortal.scss';
import 'styles/CompactViewport.scss';
import 'styles/DataGrid.scss';
import 'styles/ButtonIconSystem.scss';
import ConfirmModal from 'components/shared/ConfirmDeleteModal';
import ChunkLoadRecoveryBoundary from 'components/shared/ChunkLoadRecoveryBoundary';
import UnpaidOrderModal from 'components/shared/UnpaidOrderModal';

dayjs.locale('vi');
moment.locale('vi');

const App = () => (
  <ConfigProvider locale={viVN}>
    <Provider store={store}>
      <AuthProvider>
        <MqttProvider>
          <ChunkLoadRecoveryBoundary>
            <AppRouter />
          </ChunkLoadRecoveryBoundary>
          <ToastContainer autoClose={5000} limit={3} newestOnTop pauseOnHover />
          <ConfirmModal />
          <UnpaidOrderModal />
          <div id='bw_modal_root'></div>
        </MqttProvider>
      </AuthProvider>
    </Provider>
  </ConfigProvider>
);
export default App;
